module.exports = __webpack_public_path__ + "static/media/07-mobile-4.b095a742.png";